import { createSlice } from '@reduxjs/toolkit';
import { fetchTrainingDashboard, fetchTrainingCategories, fetchTrainingStaff, fetchTrainingRecord, fetchTrainingHistory, saveTrainingRecord } from './staffTrainingActions';
const slot = () => ({ data: null, loading: false, error: null, requestId: null });
const slice = createSlice({ name: 'staffTraining', initialState: { dashboard: slot(), categories: slot(), staff: slot(), records: {}, histories: {}, saving: false }, reducers: {},
  extraReducers: builder => {
    for (const [action, target] of [
      [fetchTrainingDashboard, state => state.dashboard], [fetchTrainingCategories, state => state.categories],
      [fetchTrainingStaff, state => state.staff],
      [fetchTrainingRecord, (state, id) => state.records[id] ||= slot()],
      [fetchTrainingHistory, (state, id) => state.histories[id] ||= slot()],
    ]) {
      builder.addCase(action.pending, (state, event) => { Object.assign(target(state, event.meta.arg), { loading: true, error: null, requestId: event.meta.requestId }); });
      builder.addCase(action.fulfilled, (state, event) => { const current = target(state, event.meta.arg); if (current.requestId === event.meta.requestId) Object.assign(current, { data: event.payload, loading: false }); });
      builder.addCase(action.rejected, (state, event) => { const current = target(state, event.meta.arg); if (current.requestId === event.meta.requestId) Object.assign(current, { loading: false, error: event.meta.aborted ? null : event.payload || 'Unable to load training records.' }); });
    }
    builder.addCase(saveTrainingRecord.pending, state => { state.saving = true; });
    builder.addCase(saveTrainingRecord.fulfilled, (state, event) => {
      state.saving = false;
      state.records[event.payload.id] = { ...slot(), data: event.payload };
      state.dashboard.data = null;
      state.histories = {};
    });
    builder.addCase(saveTrainingRecord.rejected, state => { state.saving = false; });
  },
});
export default slice.reducer;
